//Actions
import {
  SET_ADMIN_PRICING_POSTAGE_DATA,
  SET_ADMIN_PRICING_POSTAGE_LOADER,
  SET_ADMIN_PRICING_POSTAGE_HISTORICAL_DATA,
  SET_ADMIN_PRICING_PLANS_DATA,
  SET_ADMIN_PRICING_PLANS_LOADER,
  SET_ADMIN_PRICING_COST_OF_GOODS_DATA,
  SET_ADMIN_PRICING_COST_OF_GOODS_HISTORICAL_DATA,
  SET_ADMIN_PRICING_COST_OF_GOODS_LOADER,
  SET_ADMIN_PRICING_TIERS_DATA,
  SET_ADMIN_PRICING_TIERS_LOADER,
  LOGOUT,
} from '~/redux/actions/action-types';

const initialState = {
  // Postage data
  postage: {
    current: [],
    historical: [],
    rowsCount: 0,
    historicalRowsCount: 0,
    to: 20,
    from: 1,
    lastPage: 1,
    currentPage: 1,
    perPage: 20,
    totalRecordsInDB: null,
    loading: false,
    historicalPagination: {
      page: 1,
      pageSize: 20,
      lastPage: 1,
      total: 0,
      from: 1,
      to: 20,
      totalRecordsInDB: null,
    },
  },
  // Plans data
  plans: {
    data: [],
    features: [],
    versions: [],
    rowsCount: 0,
    to: null,
    from: null,
    lastPage: null,
    currentPage: null,
    perPage: 20,
    totalRecordsInDB: null,
    loading: false,
  },
  // Cost of goods data
  costOfGoods: {
    current: [],
    historical: [],
    rowsCount: 0,
    historicalRowsCount: 0,
    to: 20,
    from: 1,
    lastPage: 1,
    currentPage: 1,
    perPage: 20,
    totalRecordsInDB: null,
    loading: false,
    historicalPagination: {
      page: 1,
      pageSize: 20,
      lastPage: 1,
      total: 0,
      from: 1,
      to: 20,
      totalRecordsInDB: null,
    },
  },
  // Pricing tiers data
  tiers: {
    data: [],
    rowsCount: 0,
    to: null,
    from: null,
    lastPage: null,
    currentPage: null,
    perPage: 20,
    totalRecordsInDB: null,
    loading: false,
  },
};

const adminPricingReducers = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ADMIN_PRICING_POSTAGE_DATA:
      return {
        ...state,
        postage: {
          ...state.postage,
          current: (payload.data || payload.rows || []).map((row, index) => ({
            id: row.id ?? index,
            ...row,
          })),
          rowsCount: payload.data.length || 0,
          totalRecordsInDB: payload.meta.total,
          to: payload.meta.to,
          from: payload.meta.from,
          lastPage: payload.meta.last_page,
          currentPage: payload.meta.current_page,
          perPage: payload.meta.per_page,
        },
      };
    case SET_ADMIN_PRICING_POSTAGE_HISTORICAL_DATA:
      return {
        ...state,
        postage: {
          ...state.postage,
          historical: (payload.data || payload.rows || []).map((row, index) => ({
            id: row.id ?? index,
            ...row,
          })),
          historicalPagination: {
            rowsCount: payload.data.length || 0,
            totalRecordsInDB: payload.meta.total,
            to: payload.meta.to,
            from: payload.meta.from,
            lastPage: payload.meta.last_page,
            currentPage: payload.meta.current_page,
            perPage: payload.meta.per_page,
          },
        },
      };
    case SET_ADMIN_PRICING_POSTAGE_LOADER:
      return {
        ...state,
        postage: {
          ...state.postage,
          loading: payload,
        },
      };
    case SET_ADMIN_PRICING_PLANS_DATA:
      return {
        ...state,
        plans: {
          ...state.plans,
          data: payload.plans || payload.rows || [],
          features: payload.features || [],
          versions: payload.versions || [],
          rowsCount: payload.count || payload.plans?.length || 0,
          totalRecordsInDB: payload.totalRecordsInDB,
          to: payload.to,
          from: payload.from,
          lastPage: payload.last_page,
          currentPage: payload.currentPage,
          perPage: payload.per_page,
          meta: payload.meta
        },
      };
    case SET_ADMIN_PRICING_PLANS_LOADER:
      return {
        ...state,
        plans: {
          ...state.plans,
          loading: payload,
        },
      };
    case SET_ADMIN_PRICING_COST_OF_GOODS_DATA:
      return {
        ...state,
        costOfGoods: {
          ...state.costOfGoods,
          current: (payload.data || payload.rows || []).map((row, index) => ({
            id: row.id ?? index,
            ...row,
          })),
          rowsCount: payload.data.length || 0,
          totalRecordsInDB: payload.meta.total,
          to: payload.meta.to,
          from: payload.meta.from,
          lastPage: payload.meta.last_page,
          currentPage: payload.meta.current_page,
          perPage: payload.meta.per_page,
        },
      };
    case SET_ADMIN_PRICING_COST_OF_GOODS_HISTORICAL_DATA:
      return {
        ...state,
        costOfGoods: {
          ...state.costOfGoods,
          historical: (payload.data || payload.rows || []).map((row, index) => ({
            id: row.id ?? index,
            ...row,
          })),
          historicalPagination: {
            rowsCount: payload.data.length || 0,
            totalRecordsInDB: payload.meta.total,
            to: payload.meta.to,
            from: payload.meta.from,
            lastPage: payload.meta.last_page,
            currentPage: payload.meta.current_page,
            perPage: payload.meta.per_page,
          },
        },
      };
    case SET_ADMIN_PRICING_COST_OF_GOODS_LOADER:
      return {
        ...state,
        costOfGoods: {
          ...state.costOfGoods,
          loading: payload,
        },
      };
    case SET_ADMIN_PRICING_TIERS_DATA:
      return {
        ...state,
        tiers: {
          ...state.tiers,
          data: payload.rows || [],
          rowsCount: payload.count || 0,
          totalRecordsInDB: payload.totalRecordsInDB,
          to: payload.to,
          from: payload.from,
          lastPage: payload.last_page,
          currentPage: payload.currentPage,
          perPage: payload.per_page,
        },
      };
    case SET_ADMIN_PRICING_TIERS_LOADER:
      return {
        ...state,
        tiers: {
          ...state.tiers,
          loading: payload,
        },
      };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
};

export { adminPricingReducers };
